import { Controller } from "@hotwired/stimulus"

// Shows the resume-date field only when they pick "a date", and opens the
// native calendar so "Pick a date" is not just another radio.
export default class extends Controller {
  static targets = ["mode", "datePanel", "dateField", "summary"]

  connect() {
    this.sync()
  }

  modeChanged() {
    this.sync({ openPicker: this.selectedMode === "date" })
  }

  sync({ openPicker = false } = {}) {
    const picked = this.selectedMode === "date"
    if (this.hasDatePanelTarget) {
      this.datePanelTarget.classList.toggle("hidden", !picked)
      this.datePanelTarget.setAttribute("aria-hidden", picked ? "false" : "true")
    }
    if (this.hasDateFieldTarget) {
      this.dateFieldTarget.required = picked
    }
    if (this.hasSummaryTarget) {
      const open = this.selectedMode === "until_resume"
      this.summaryTarget.textContent = open
        ? this.summaryTarget.dataset.open
        : this.summaryTarget.dataset.dated
    }
    if (openPicker) this.openNativePicker()
  }

  openNativePicker() {
    if (!this.hasDateFieldTarget) return

    this.dateFieldTarget.focus()
    requestAnimationFrame(() => {
      try {
        this.dateFieldTarget.showPicker?.()
      } catch {
        // Field is visible even if the browser refuses showPicker.
      }
    })
  }

  get selectedMode() {
    const checked = this.modeTargets.find((el) => el.checked)
    return checked?.value || "thirty"
  }
}
